export const costeDeEnvio = 1000;
export const idcliente = "7098d9f8-de4c-4d27-9e93-60823a16d405";
export const ulogin = "ecommerce_test_api";
export const uclave = "api_test_ecommerce";
